import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChart3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"chart-3, statistics, graph, signal"} maskId="square-filled-radius-0-stroke-1-IconChart3"><path d="M20.9999 3H15.6699V21H20.9999V3Z" fill="currentColor"/><path d="M14.6601 8.33398H9.33008V21.0007H14.6601V8.33398Z" fill="currentColor"/><path d="M8.33 12.7773H3V20.9996H8.33V12.7773Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconChart3;
